<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="600">
    <div class="white pa-7">
      <v-row>
        <v-col cols="12">
          <p class="form__title primary--text mb-5">
            Boletos
          </p>
          <DocumentDataTable
            :documents="items"
            @preview-file="onPreviewFile"
            :delete-button="false"
          />
        </v-col>
      </v-row>
      <v-row class="pt-5">
        <v-spacer />
        <v-col cols="12" sm="3">
          <BaseButton
            @click="$emit('close')"
            class="secondary"
            width="100%"
            v-html="'FECHAR'"
          />
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DocumentDataTable from "@/components/DocumentDataTable";
export default {
  components: {
    DocumentDataTable
  },
  mixins: [DocumentsMixin],
  props: {
    items: {
      type: Array
    }
  }
};
</script>
